import { selector } from "recoil"

import {
  findPanelState,
  panelIndex,
} from "~/containers/LegacyDesigner/state/elements/panels"
import { panelBeingDraggedState } from "~/containers/LegacyDesigner/state/elements/panels/dragging"
import { getPanelIsError } from "~/containers/LegacyDesigner/state/elements/panels/validation"
import type { TransactionOperation } from "~/containers/LegacyDesigner/state/elements/transactions/transactors"
import { readonlyTransactors } from "~/containers/LegacyDesigner/state/elements/transactions/transactors"

import { isPanel, type Panel } from "./design-model"

export const PANEL_ORIENTATIONS = [`Landscape`, `Portrait`] as const

export type PanelOrientation = (typeof PANEL_ORIENTATIONS)[number]

export const getProductivePanels: TransactionOperation<
  undefined,
  (Panel & { id: string })[]
> = (transactors) => {
  const { get } = transactors
  const panelIsBeingDragged = get(panelBeingDraggedState)
  if (panelIsBeingDragged !== null) {
    return []
  }

  const panelIds = get(panelIndex)
  const productivePanels: (Panel & { id: string })[] = panelIds
    .map((id) => {
      const panel = get(findPanelState(id))
      if (panel.isActive === false) return null
      const isError = getPanelIsError(transactors, id)
      if (isError) return null

      return { ...panel, id }
    })
    .filter(isPanel) as (Panel & { id: string })[]

  return productivePanels
}

export const productivePanelsState = selector<(Panel & { id: string })[]>({
  key: `productivePanels`,
  get: ({ get }) => getProductivePanels(readonlyTransactors(get)),
})

export const productivePanelsCountState = selector<number>({
  key: `productivePanelsCount`,
  get: ({ get }) => getProductivePanels(readonlyTransactors(get)).length,
})
